/** @format */

import * as mobx from 'mobx';
import { INavigationBarVisibilityStore } from './domain';
const { observable, action, configure } = mobx;

configure({
  enforceActions: 'always',
});

let recentOffsets = [];

const navigationBarVisibility = observable({
  showing: true,
  show: action.bound(function show() {
    this.showing = true;
  }),
  hide: action.bound(function hide() {
    this.showing = false;
  }),
});

const rankScrollHandler = (e) => {
  const currentOffset = e.nativeEvent.contentOffset.y;

  recentOffsets.unshift(currentOffset);
  recentOffsets = recentOffsets.slice(0, 5);
  if (recentOffsets.length === 5 && Math.abs(recentOffsets[0] - recentOffsets[4]) > 60) {
    if (recentOffsets.every((value, index, arr) => (index === 0 ? true : value < arr[index - 1]))) {
      navigationBarVisibility.hide();
    } else if (recentOffsets.every((value, index, arr) => (index === 0 ? true : value > arr[index - 1]))) {
      navigationBarVisibility.show();
    }
  }
};

export default navigationBarVisibility;
export { rankScrollHandler };
